<div class="content">
  <div *ngIf="!goForm" class="row">
    <div class="col-12">
      <p class="text-title-card">Apis social Link</p>
    </div>
    <div class="col-4" *ngFor="let aviableApi of aviableApis">
      <div class="card" (click)="goFormClick(aviableApi)">
        <h3>Descripción</h3>
        <p>{{ aviableApi.descripcion }}</p>
      </div>
    </div>
  </div>
  <div *ngIf="goForm" class="form">
    <div class="return">
      <button mat-icon-button (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>

    <p class="selected_api_name">{{ apiSelect.descripcion }}</p>
    <form [formGroup]="form" *ngIf="!spiner">
      <!-- Contenedor principal con display: grid -->
      <div class="form-grid">
        <!-- Itera sobre las llaves del FormGroup -->
        <div *ngFor="let key of getFormKeys()" class="form-field">
          <!-- Campo de Angular Material -->
          <mat-form-field appearance="outline">
            <mat-label>{{ key }}</mat-label>
            <input
              matInput
              [formControlName]="key"
              type="text"
              [placeholder]="apiSelect.params[key].description"
            />
            <!-- Mensaje de error -->
            <mat-error
              *ngIf="
                form.get(key).hasError('required') && form.get(key).touched
              "
            >
              Este campo es requerido.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div>
        <button
          mat-raised-button
          class="primary-btn rounded"
          [disabled]="!form.valid || spiner"
          (click)="getResult()"
        >
          Buscar
        </button>
      </div>
    </form>
    <mat-spinner *ngIf="spiner"></mat-spinner>
  </div>
</div>
